export default function () {
    return (
        <svg width="351" height="82" viewBox="0 0 351 82" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M229.683 50.1596H237.687L248.262 10.6747H240.266L229.683 50.1596Z" fill="white" />
            <path
                d="M162.138 32.6132H151.7L157.019 41.9334H138.547C138.164 41.9555 137.796 41.7824 137.569 41.4735C137.342 41.1646 137.286 40.7617 137.422 40.403L142.778 20.431C143.035 19.5631 143.81 18.9505 144.714 18.9006H169.966C170.348 18.8812 170.713 19.0554 170.938 19.3639C171.164 19.6724 171.218 20.0736 171.083 20.431L167.984 32.001L173.402 41.4896C173.456 41.3213 173.517 41.1529 173.563 40.9846L179.225 19.8571C180.587 14.7837 177.572 10.6746 172.507 10.6746H146.612C141.546 10.6746 136.335 14.7837 134.973 19.8571L129.31 40.9846C127.956 46.0503 130.963 50.1671 136.029 50.1671H172.185L162.138 32.6132Z"
                fill="white"
            />
            <path
                d="M215.971 42.2089H188.194L196.611 10.7052H188.385L179.861 42.538C178.728 46.7696 181.238 50.1901 185.462 50.1901H222.032L232.615 10.7052H224.388L215.971 42.2089Z"
                fill="white"
            />
            <path d="M350.166 10.6747H305.852L303.648 18.8854H321.807L313.428 50.1596H321.432L329.811 18.8854H347.97L350.166 10.6747Z" fill="white" />
            <path d="M245.316 50.1596H289.538L291.734 41.9642H255.517L257.506 34.5187H293.731L295.928 26.3157H251.706L245.316 50.1596Z" fill="white" />
            <path d="M253.703 18.8777H297.925L300.121 10.6747H255.899L253.703 18.8777Z" fill="white" />
            <path d="M100.921 34.5569H123.013L125.209 26.3462H103.125L100.921 34.5569Z" fill="white" />
            <path d="M54.5033 0H32.228L51.6874 26.3232L65.8897 15.4267L54.5033 0Z" fill="white" />
            <path d="M77.2072 60.8418H99.4825L81.6302 36.6918L66.2646 46.035L77.2072 60.8418Z" fill="white" />
            <path d="M119.883 0H91.8994L43.5151 37.1204H54.1056L0.625 82L92.2439 26.3539H81.5309L119.883 0Z" fill="url(#paint0_linear_540_1721)" />
            <defs>
                <linearGradient id="paint0_linear_540_1721" x1="113.287" y1="-5.23546e-07" x2="0.764685" y2="81.8659" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#EAC64C" />
                    <stop offset="0.554786" stopColor="#C09325" />
                    <stop offset="1" stopColor="#AF7D14" />
                </linearGradient>
            </defs>
        </svg>
    );
}
